/**
 * Тона меток — фон и текст. Одна палитра на ERP: чипы, бейджи и цветные
 * кромки берут цвет отсюда, а не заводят свои hex рядом.
 *
 * Живёт в `components/constants`, а не в `pages/_detailShared/detail.styled`
 * (ТЗ 0096): значки коммуникаций рисует и шапка меню (organism), а
 * organism/molecule не импортирует страницы. `detail.styled` реэкспортирует
 * всё отсюда — прежние импорты работают.
 */
export type TagTone = 'ok' | 'warn' | 'danger' | 'neutral' | 'info' | 'gold';

export const TAG_TONE_COLORS: Readonly<
  Record<TagTone, { bg: string; fg: string }>
> = {
  ok: { bg: '#dcfce7', fg: '#166534' },
  warn: { bg: '#ffedd5', fg: '#9a3412' },
  danger: { bg: '#fee2e2', fg: '#991b1b' },
  info: { bg: '#dbeafe', fg: '#1e40af' },
  gold: { bg: '#fef9c3', fg: '#854d0e' },
  neutral: { bg: '#f1f5f9', fg: '#475569' },
};

/** Цвета тона; незнакомый тон — нейтральный (как было у `Tag`). */
export const tagToneColors = (tone?: TagTone | null) =>
  (tone && TAG_TONE_COLORS[tone]) || TAG_TONE_COLORS.neutral;
